import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { FilteredPollsBuilder } from '../../models/builder/filtered-polls.builder';
import { HistoricalBuilder } from '../../models/builder/historical.builder';
import { PollGroupBuilder } from '../../models/builder/poll-group.builder';
import { PollGroupsRequestInterface } from '../../models/request/poll-groups-request.interface';

@Injectable()
export class PollGroupApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.companyAdmin.apiUrl}poll-groups`;
  }

  getPollGroup(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(map(PollGroupBuilder.fromJson));
  }

  createPollGroup(pollGroupBody) {
    return this.httpClient.post(`${this.apiUrl}`, pollGroupBody)
      .pipe(
        map(PollGroupBuilder.fromJson)
      );
  }

  updatePollGroup(pollGroupBody) {
    const hash = pollGroupBody.hash;
    return this.httpClient.put(`${this.apiUrl}/${hash}`, pollGroupBody)
      .pipe(
        map(PollGroupBuilder.fromJson)
      );
  }

  deletePollGroup(hash: string) {
    return this.httpClient.delete(`${this.apiUrl}/${hash}`)
      .pipe(
        map(PollGroupBuilder.fromJson)
      );
  }

  getFilteredPollGroupPolls(pollGroupHash: string, pollHash: string, request: PollGroupsRequestInterface) {
    let params = new HttpParams();
    params = params.append('pollHash', pollHash)
      .append('page', request.page.toString())
      .append('itemsPerPage', request.itemsPerPage.toString())
      .append('sortField', request.sortField)
      .append('reversed', (!!request.reversed).toString());

    return this.httpClient.get(`${this.apiUrl}/${pollGroupHash}/polls`, { params: params })
      .pipe(map(FilteredPollsBuilder.fromJson));
  }

  getHistorical(pollGroupHash) {
    const params = new HttpParams().append('pollGroupHash', pollGroupHash ? pollGroupHash : '');

    return this.httpClient.get(`${this.apiUrl}/historical`, { params })
      .pipe(map(HistoricalBuilder.fromList));
  }
}
